<!--
UserFilters component
Usage: <UserFilters :filters="<array containing filters>"  /> (see AF.vue)
@author cm359n
-->
<template>
    <div id="filter-list">
        <div class="filter-message">{{ message }}</div>
        <div class="fl-scrollover filter-list">
        <button @click="doFilter(filter)"
            :class="filtersApplied(filter.name) !== '' ? 'filter-item-selected' : 'filter-item'"
            v-bind:key="index"
            v-for="(filter, index) in filterList" >
            {{ displayName(filter) }} {{ filtersApplied(filter.name) }}
        </button>
        </div>
    </div>
</template>
<script>
import AssFeedCommon from '@/mixins/AssFeedCommon.js'
import AFFilterCommon from '@/mixins/AFFilterCommon.js'

export default {
  name: 'UserFilters',
  props: ['message', 'filters', 'filterDates'], /* each filter should have a 'name' and 'selected' value (object, string, whatever) */
  components: {
  },
  data () {
    let fl = []
    for (let filterName in this.filters) {
      const order = this.filters[filterName].order
      fl[order] = ({
        'name': filterName,
        'displayName': this.filters[filterName].displayName,
        'alternateField': this.filters[filterName].alternateField,
        'selected': this.filters[filterName].selected
      })
    }

    return {
      showing: this.toggle,
      filterList: fl
    }
  },
  mixins: [AssFeedCommon, AFFilterCommon],
  mounted () {

  },
  methods: {
    filtersApplied (fname) {
      let ret = ''
      let filtCount = 0
      const selectedFilters = this.filters[fname].selected // see AF.vue for structure of 'filters'

      let dateFilt = '' // if a date filter was selected, we display its name, not the count.
      for (const filt in selectedFilters) {
        const optionSelected = selectedFilters[filt]
        if (optionSelected) {
          filtCount++
          if (fname == 'dates') {
            dateFilt = this.filters[fname].fmap[filt]
          }
        }
      }

      if (fname == 'dates' && dateFilt != '') {
        // which option is it?
        // console.log('i think the date filter option ' + dateFilt + ' was selected')
        if (dateFilt == 'Range') {
          const dateFrom = this.filterDates.from
          const dateTo = this.filterDates.to
          ret = ' (' + dateFrom + ':' + dateTo + ')'
        } else {
          ret = ' (' + dateFilt + ')'
        }
      } else {
        if (filtCount > 0) {
          ret = ' (' + filtCount + ')'
        }
      }

      return ret
    },
    doFilter (filter) {
      // TODO: emit to parent so they can open the drawer with the filter specifics
      this.$emit('filterClicked', filter)
    }
  }
}

</script>
<style lang="scss" scoped>
@import '@/scss/common-styles.scss';
  .filter-list {
    margin-left: 16px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .filter-message {
    font-size: 14px;
    margin-top: 10px;
    padding-bottom: 8px;
    text-align: center;
    color: var(--uog-dark-blue);
  }
  .filter-item {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    border: 1px var(--uog-dark-blue) solid;
    border-radius: 15px;
    padding: 4px 12px 4px 12px;
    margin: 3px;
    color: var(--uog-dark-blue);
    background-color:#ffffff;
  }
  .filter-item-selected {
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    border: 1px var(--uog-dark-blue) solid;
    border-radius: 15px;
    padding: 4px 12px 4px 12px;
    margin: 3px;
    color: #ffffff;
    background-color: var(--uog-dark-blue);
  }
  .modal-bg-show {
    visibility: visible;
  }
  .modal-bg-hide {
    visibility: hidden;
  }
  .modal-background {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0); /* fallback colour */
    background-color: rgba(0,0,0,0.2); /* black with opacity */
  }
  .drawer-content {
    margin-left: 30px;
    margin-right: 30px;
  }
  .drawer-top {
    height: 40px;
    background-color: white;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}
  .uog-drawer {
    position: fixed;
   bottom: 45px;
    width: 100%;
    background-color: white;
     border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .drawer-show {
    visibility: visible;
  }
  .drawer-hide {
    visibility: hidden;
  }
  .fl-scrollover {
    overflow-x:auto;
    overflow-y:hidden;
    white-space: nowrap;

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
  .fl-scrollover::-webkit-scrollbar {
    display: none;
  }
</style>
